import { render, staticRenderFns } from "./TransferHistory.vue?vue&type=template&id=cb859b00"
import script from "./TransferHistory.vue?vue&type=script&lang=js"
export * from "./TransferHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports